import GET_EDUCATIONS from '../actions/const';

const initialState = {
  educations: {
    Groupings: [],
    Items: [],
  },
  loaded: false,
};

export default (state = initialState, action) => {
  const nextState = { ...state };

  switch (action.type) {
    case GET_EDUCATIONS: {
      const { data } = action.payload;
      nextState.educations.Groupings = data.Groupings;
      nextState.educations.Items = data.Items;
      nextState.loaded = true;
      return nextState;
    }
    default: {
      return state;
    }
  }
};
